import React from 'react';
import TypeChips from './components/TypeChips';
import RangeSliderWithInputs from './components/RangeSliderWithInputs';
import AdvancedDrawer from './components/AdvancedDrawer';

const PROPERTY_TYPES = [
    { value: 'flat', label: 'Flat' },
    { value: 'villa', label: 'Villa' },
    { value: 'plot', label: 'Plot' },
    { value: 'commercial', label: 'Commercial' },
];

export default function IntentSellForm({ data, onChange }) {
    const updateBasics = (field, value) => onChange('basics', field, value);
    const updateBudget = (field, value) => onChange('budget', field, value); // used for "Expected Price"
    const updateSpecs = (field, value) => onChange('specifications', field, value);

    const { basics = {}, budget = {}, specifications = {} } = data;
    // Extract listingType from root data or use default 'sell'
    const listingType = data.listingType || 'sell';
    const setListingIntent = (value) => {
        onChange(null, 'listingType', value);
        onChange(null, 'sellerListingIntent', value === 'rent' ? 'rent' : 'sale');
    };

    return (
        <div className="req-grid">
            <div className="req-col-span-2">
                <h3 className="req-section-title">Listing Details</h3>
            </div>

            {/* LISTING TYPE TOGGLE */}
            <div className="req-col-span-2 req-field">
                <label className="req-label">I want to</label>
                <div style={{ display: 'flex', gap: '0', background: 'var(--req-surface)', border: '1px solid var(--req-border)' }}>
                    <button
                        style={{
                            flex: 1, padding: '10px',
                            background: listingType === 'sell' ? 'var(--req-active-bg)' : 'transparent',
                            color: listingType === 'sell' ? 'var(--req-active-text)' : 'var(--req-text-dim)',
                            border: 'none', cursor: 'pointer', fontWeight: '600',
                            borderRadius: 0
                        }}
                        onClick={() => setListingIntent('sell')}
                    >
                        SELL PROPERTY
                    </button>
                    <div style={{ width: '1px', background: 'var(--req-border)' }}></div>
                    <button
                        style={{
                            flex: 1, padding: '10px',
                            background: listingType === 'rent' ? 'var(--req-active-bg)' : 'transparent',
                            color: listingType === 'rent' ? 'var(--req-active-text)' : 'var(--req-text-dim)',
                            border: 'none', cursor: 'pointer', fontWeight: '600',
                            borderRadius: 0
                        }}
                        onClick={() => setListingIntent('rent')}
                    >
                        RENT OUT PROPERTY
                    </button>
                </div>
            </div>

            <div className="req-field req-col-span-2">
                <label className="req-label">Property Type</label>
                <TypeChips
                    options={PROPERTY_TYPES}
                    value={basics.propertyTypes || []}
                    onChange={(val) => updateBasics('propertyTypes', val)}
                    limit={null}
                    single={true}
                />
            </div>

            <div className="req-col-span-2 req-field">
                <label className="req-label">Exact Address</label>
                <textarea
                    className="req-input"
                    rows={2}
                    placeholder="Full address of property to sell"
                    value={basics.address || ''}
                    onChange={(e) => updateBasics('address', e.target.value)}
                />
            </div>

            <div className="req-field">
                <label className="req-label">Pincode</label>
                <input
                    type="text"
                    className="req-input"
                    placeholder="e.g. 560001"
                    value={basics.pincode || ''}
                    onChange={(e) => updateBasics('pincode', e.target.value)}
                />
            </div>

            <div className="req-field">
                <label className="req-label">Expected Price</label>
                <input
                    type="number"
                    className="req-input"
                    value={budget.min || ''}
                    onChange={(e) => {
                        updateBudget('min', e.target.value);
                        updateBudget('max', e.target.value); // Usually single price for sell
                    }}
                    placeholder="Price in INR"
                />
            </div>

            <div className="req-field">
                <label className="req-label">Area (Sqft)</label>
                <input
                    type="number"
                    className="req-input"
                    value={specifications.areaMin || ''}
                    onChange={(e) => {
                        updateSpecs('areaMin', e.target.value);
                        updateSpecs('areaMax', e.target.value);
                    }}
                    placeholder="Total Area"
                />
            </div>

            <div className="req-col-span-2">
                <AdvancedDrawer>
                    <div className="req-field">
                        <label className="req-label">Ownership Status</label>
                        <select
                            className="req-input"
                            value={data.advanced?.ownership || 'freehold'}
                            onChange={(e) => onChange('advanced', 'ownership', e.target.value)}
                        >
                            <option value="freehold">Freehold</option>
                            <option value="leasehold">Leasehold</option>
                            <option value="power_of_attorney">Power of Attorney</option>
                        </select>
                    </div>
                </AdvancedDrawer>
            </div>
        </div>
    );
}
